import { FC, PropsWithChildren, ReactNode } from "react";
import { LoadingGroup } from "../LoadingGroup";
import { BaseProps } from "../../BaseProps";
import { Shelf, Spacing } from "../../layout";
import { Spinner, SpinnerColor, SpinnerSize } from "../Spinner";
import { Paragraph } from "../../typography";

/**
 * The DataList `LoadingState` component properties.
 */
export interface LoadingStateProps extends BaseProps {
  /** The loading message */
  readonly loadingMessage?: ReactNode;

  /** The loading spinner size. */
  readonly size?: SpinnerSize;

  /** The loading spinner color. */
  readonly color?: SpinnerColor;

  /** The spacing between loading label and spinner*/
  readonly spacing?: Spacing;
}

/**
 * A component which renders the loading state when a loading operation on DataLits is taking place. If not loading, the children of the component is rendered.
 */
export const LoadingState: FC<PropsWithChildren<LoadingStateProps>> = ({
  testId,
  loadingMessage,
  children,
  size = "large",
  color = "turquoise",
  spacing = "small",
}: PropsWithChildren<LoadingStateProps>): JSX.Element => {
  return (
    <LoadingGroup.Placeholder
      fallback={
        <Shelf spacing={spacing} alignment="span" testId={`${testId}-loading-state`}>
          <Spinner size={size} color={color} />
          <Paragraph>{loadingMessage}</Paragraph>
          <Shelf.Spacer />
        </Shelf>
      }
    >
      {children}
    </LoadingGroup.Placeholder>
  );
};
